<template>
  <section>
    <b-row>
      <b-form-group class="col-12" label="Storefronts:">
        <b-v-select-multiple :disabled="viewOnly"
          name="form-input-storefrontIdsPicked"
          v-model="storefrontIdsPicked"
          :searchable="true"
          :options="projectsListAll" />
      </b-form-group>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'StorefrontReshipReportByMonth-form',
  components: {
  },
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'storefrontIdsPicked': function(val) {
      let arr = [];
      if(val.length>0) {
        val.forEach((it) => {
          arr.push(it.value);
        })
      }
      this.reportFilters.storefrontIds = arr;
    }
  },
  data() {
    return {
      storefrontIdsPicked: []
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjects: 'getMyProjects'
    }),
    projectsListAll: {
      get() {
        return [
          {
            value: '',
            text: 'All'
          },
          ...this.projectsList
        ];
      }
    },
  },
  mounted() {
    if (!this.reportFilters.storefrontIds) {
      this.$set(this.reportFilters, 'storefrontIds', []);
    }
  }
}
</script>

<style>

</style>